// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__3BUBn","active":"Tab_active__kZ+80"};